import PropTypes from "prop-types";
import React from "react";
import { Mutation, Query } from "react-apollo";

import {
  CREATE_STORYARTICLE,
  DELETE_STORYARTICLE,
  EXPORT_STORY,
  GET_STORIES,
  UPDATE_STORYARTICLE,
} from "./../../gql";

import Accordion from "../../components/Accordion";
import PagePagination from "../../components/PagePagination";
import Throbber from "../../components/Throbber";
import StorySections from "./StorySections";

import bookmarkIcon from "./../../../images/icons/bookmark-blue.svg";
import roundPlus from "./../../../images/icons/round-plus-white.svg";

class Stories extends React.Component {
  constructor() {
    super();
    this.state = {
      storyArticleUpdate: {},
      publishIsUpToDate: null,
    };
    this.storyArticles = [];
    this.activatePublishButton = this.activatePublishButton.bind(this);
    this.activateUnpublishedAlert = this.activateUnpublishedAlert.bind(this);
  }

  componentDidMount() {
    const { client } = this.props;
    client.writeData({
      data: {
        currentContentType: "STORYARTICLE",
      },
    });
  }

  componentWillUnmount() {
    const { client } = this.props;
    client.writeData({
      data: {
        unpublishWarning: false,
      },
    });
  }

  activateUnpublishedAlert() {
    const { client } = this.props;
    client.writeData({
      data: {
        unpublishWarning: true,
      },
    });
  }

  componentDidUpdate(prevProps) {
    const { published } = this.props;

    if (!published && prevProps.published) {
      this.setState({
        publishIsUpToDate: false,
      });
    }

    if (published && !prevProps.published) {
      this.setState({
        publishIsUpToDate: true,
      });
    }
  }

  deleteStoryArticle(id, deleteStoryArticle) {
    if (confirm("Are you sure you want to delete this storyArticle?")) {
      deleteStoryArticle({
        variables: { id },
      });
      this.activatePublishButton();
      this.activateUnpublishedAlert();
    }
  }

  createStoryArticle(createStoryArticle, storyArticles) {
    const { app, languageCode } = this.props;

    const orderIndex =
      storyArticles.length > 0
        ? storyArticles[storyArticles.length - 1].meta.displayOrder + 1
        : 0;

    createStoryArticle({
      variables: {
        title: "",
        subtitle: "",
        languageCode: languageCode,
        app: app,
        displayOrder: orderIndex,
      },
    });
    this.activatePublishButton();
    this.activateUnpublishedAlert();
  }

  activatePublishButton() {
    const { client } = this.props;
    client.writeData({
      data: {
        publishDisabled: false,
        queryRefetchAfterPublish: ["GET_STORIES"],
      },
    });
  }

  submitUpdate(updateStoryArticle) {
    const { storyArticleUpdate } = this.state;
    updateStoryArticle({
      variables: storyArticleUpdate,
    });
    this.setState({
      storyArticleUpdate: {},
    });
    this.activatePublishButton();
    this.activateUnpublishedAlert();
  }

  onChangeHandle(event, updateStoryArticle, id) {
    const { app, languageCode } = this.props;
    const name = event.target.name;
    const value = event.target.value;

    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.submitUpdate(updateStoryArticle), 500);

    this.setState((prevState) => {
      if (
        prevState.storyArticleUpdate &&
        prevState.storyArticleUpdate.id === id
      ) {
        return {
          storyArticleUpdate: {
            ...this.state.storyArticleUpdate,
            id: id,
            [name]: value,
          },
        };
      }
      return {
        storyArticleUpdate: {
          languageCode,
          app,
          published: false,
          id,
          [name]: value,
        },
      };
    });
  }

  updateDisplayOrder(id, order, updateFunc) {
    const { app, languageCode } = this.props;

    updateFunc({
      variables: {
        id,
        app,
        languageCode,
        published: false,
        displayOrder: order,
      },
    });
    this.activatePublishButton();
    this.activateUnpublishedAlert();
  }

  downloadStoryFile(url) {
    // download file from url
    const pathname = new URL(url).pathname;
    const filename = pathname.substring(pathname.lastIndexOf("/") + 1);

    // eslint-disable-next-line no-console
    console.log({ url });

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
  }

  publishNotification() {
    const { publishIsUpToDate } = this.state;

    if (publishIsUpToDate === null) {
      this.activatePublishButton();
    } else if (publishIsUpToDate) {
      return;
    }

    return (
      <div className="notification notification--warning">
        <p className="notification__description">
          The content below has not been published yet.
        </p>
      </div>
    );
  }

  render() {
    const { app, languageCode, published } = this.props;

    return (
      <div>
        <div className="right-align u-margin--bottom-large">
          <Mutation
            update={(cache, { data }) => {
              this.downloadStoryFile(data.exportStoryToCSV);
            }}
            mutation={EXPORT_STORY}
            variables={{
              languageCode: languageCode,
              app: app,
              published: published,
            }}
          >
            {(exportStoryToCSV, { loading }) => (
              <div className="relative-block right-align">
                <button
                  onClick={() => exportStoryToCSV()}
                  className="button button--link"
                >
                  Download entire stories
                </button>
                <Throbber
                  hidden={!loading}
                  loadingText="Downloading..."
                  alignRight
                />
              </div>
            )}
          </Mutation>
        </div>
        <Query
          query={GET_STORIES}
          variables={{
            languageCode: languageCode,
            app: app,
            limit: 1000,
          }}
        >
          {({ data, loading, error, fetchMore }) => {
            if (loading)
              return <p className="full-width center-align">Loading...</p>;
            if (error)
              return <p className="full-width center-align">{error.message}</p>;
            const { stories } = data;
            this.storyArticles = stories.edges;
            return (
              <div>
                {stories.edges.length > 0 ? (
                  <div>
                    {stories.edges
                      .sort((a, b) => a.meta.displayOrder - b.meta.displayOrder)
                      .map((storyArticle) => (
                        <Mutation
                          key={storyArticle.id}
                          mutation={DELETE_STORYARTICLE}
                          refetchQueries={[
                            {
                              query: GET_STORIES,
                              variables: {
                                languageCode: languageCode,
                                app: app,
                                limit: 1000,
                              },
                            },
                          ]}
                        >
                          {(deleteStoryArticle, { loading, error }) => (
                            <div className="relative-block">
                              {error && (
                                <p className="full-width center-align">
                                  {error.message}
                                </p>
                              )}
                              {!storyArticle.availability.published &&
                                this.publishNotification()}
                              <Mutation mutation={UPDATE_STORYARTICLE}>
                                {(updateStoryArticle) => (
                                  <Accordion
                                    showColorPicker
                                    twoHeaderInputs
                                    enableOrdering
                                    enableChangeIcon
                                    id={storyArticle.id}
                                    title={storyArticle.title}
                                    subtitle={storyArticle.subtitle}
                                    titleColor={storyArticle.color}
                                    headerIcon={
                                      storyArticle.icon || bookmarkIcon
                                    }
                                    displayOrder={
                                      storyArticle.meta.displayOrder
                                    }
                                    siblingAccordions={stories.edges}
                                    updateDisplayOrder={(id, order) =>
                                      this.updateDisplayOrder(
                                        id,
                                        order,
                                        updateStoryArticle
                                      )
                                    }
                                    onChanges={(event) =>
                                      this.onChangeHandle(
                                        event,
                                        updateStoryArticle,
                                        storyArticle.id
                                      )
                                    }
                                    deleteAccordion={() =>
                                      this.deleteStoryArticle(
                                        storyArticle.id,
                                        deleteStoryArticle
                                      )
                                    }
                                  >
                                    <StorySections
                                      storyArticleId={storyArticle.id}
                                      storySections={storyArticle.storySections}
                                      languageCode={languageCode}
                                      published={published}
                                      app={app}
                                      activatePublishButton={
                                        this.activatePublishButton
                                      }
                                      activateUnpublishedAlert={
                                        this.activateUnpublishedAlert
                                      }
                                    />
                                  </Accordion>
                                )}
                              </Mutation>
                              <Throbber
                                hidden={!loading}
                                loadingText="Deleting storyArticle..."
                              />
                            </div>
                          )}
                        </Mutation>
                      ))}
                  </div>
                ) : (
                  <p className="full-width center-align">
                    No storyArticles found.
                  </p>
                )}
                <PagePagination
                  pageInfo={stories.pageInfo}
                  onPageClick={(endCursor) =>
                    fetchMore({
                      query: GET_STORIES,
                      variables: {
                        languageCode: languageCode,
                        app: app,
                        limit: 1000,
                        cursor: endCursor,
                      },
                      updateQuery: (previousResult, { fetchMoreResult }) => {
                        const previous = previousResult.stories;
                        const newArticles = fetchMoreResult.stories.edges;

                        const newCursor =
                          fetchMoreResult.stories.pageInfo.endCursor;

                        // this is the updated data, and it must keep the same structure as the original data
                        return {
                          cursor: newCursor,
                          stories: {
                            edges: [...newArticles],
                            __typename: previous.__typename,
                            pageInfo: {
                              endCursor: newCursor,
                              ...fetchMoreResult.stories.pageInfo,
                              __typename: previous.pageInfo.__typename,
                            },
                          },
                        };
                      },
                    })
                  }
                />
              </div>
            );
          }}
        </Query>
        <Mutation
          mutation={CREATE_STORYARTICLE}
          refetchQueries={[
            {
              query: GET_STORIES,
              variables: {
                languageCode: languageCode,
                app: app,
                limit: 1000,
              },
            },
          ]}
        >
          {(createStoryArticle, { loading, error }) => (
            <div className="full-width right-align relative-block">
              <Throbber
                hidden={!loading}
                loadingText="Creating storyArticle..."
              />
              {error && (
                <p className="full-width center-align">{error.message}</p>
              )}
              <button
                className="button button--small button--icon-text"
                disabled={loading}
                onClick={() =>
                  this.createStoryArticle(
                    createStoryArticle,
                    this.storyArticles
                  )
                }
              >
                <img
                  src={roundPlus}
                  alt="Add new storyArticle"
                  className="button__icon"
                />
                Add new storyArticle
              </button>
            </div>
          )}
        </Mutation>
      </div>
    );
  }
}

Stories.propTypes = {
  app: PropTypes.string.isRequired,
  published: PropTypes.bool.isRequired,
  languageCode: PropTypes.string.isRequired,
  client: PropTypes.object.isRequired,
};

export default Stories;
